interface RequestOptions {
  //method: string;
  //headers?: Record<string, string>;
  body?: any;
}

class ServiceRequest {
  url: URL;
  method: string;
  //headers//: Record<string, string>;
  options?: RequestOptions

  constructor(url: string, method: string, options?: RequestOptions) {
    this.url = new URL(url);
    this.method = method;
    this.options = options;
  }
}

export { RequestOptions };

export default ServiceRequest;